import { TOURNAMENT_STATUS, UI_TEXT } from './utils/constants.js';
import { ACTIONS } from './utils/tournamentReducer.js';
import MatchView from './MatchView.jsx';
import ResultScreen from './ResultScreen.jsx';
import RankingScreen from './RankingScreen.jsx';
import './WooltariCup.css';

/**
 * WooltariCup - Tournament-style ideal type world cup component
 * @param {Object} props
 * @param {Object} props.state - Tournament state from reducer
 * @param {Function} props.dispatch - Dispatch function from reducer
 * @param {string} props.language - Language code ('ko' or 'en')
 */
export default function WooltariCup(props) {
  const { state, dispatch, language = 'ko', token } = props;

  const handleSelectWinner = (winner) => {
    dispatch({
      type: ACTIONS.SELECT_WINNER,
      payload: { winner },
    });

    // MatchView handles the animation timing, so dispatch immediately
    dispatch({ type: ACTIONS.NEXT_MATCH });
  };

  const handleRestart = () => {
    dispatch({ type: ACTIONS.RESTART_TOURNAMENT });
  };

  const handleShowRankings = () => {
    dispatch({ type: ACTIONS.SHOW_RANKINGS });
  };

  const handleHideRankings = () => {
    dispatch({ type: ACTIONS.HIDE_RANKINGS });
  };

  // Don't render until initialized
  if (state.rounds.length === 0) {
    const text = UI_TEXT[language] || UI_TEXT.ko;
    return (
      <div className="wooltari-cup">
        <div className="wooltari-cup__loading">{text.loading}</div>
      </div>
    );
  }

  const isComplete = state.status === TOURNAMENT_STATUS.COMPLETED;
  const isShowingRankings = state.status === TOURNAMENT_STATUS.SHOWING_RANKINGS;

  return (
    <div className="wooltari-cup">
      {isShowingRankings ? (
        <RankingScreen
          onBack={handleHideRankings}
          language={language}
        />
      ) : isComplete ? (
        <ResultScreen
          champion={state.champion}
          onRestart={handleRestart}
          onShowRankings={handleShowRankings}
          dispatch={dispatch}
          language={language}
          token={token}
        />
      ) : (
        <MatchView
          key={`round-${state.currentRound}-match-${state.currentMatchIndex}`}
          currentRound={state.rounds[state.currentRound]}
          currentMatchIndex={state.currentMatchIndex}
          onSelectWinner={handleSelectWinner}
          totalRounds={state.rounds.length}
          language={language}
        />
      )}
    </div>
  );
}